import { HttpError } from '../error';
export var createErrorMetadata = function createErrorMetadata(error) {
  return {
    error: {
      name: error.name,
      message: error.message,
      stack: error.stack,
      traceId: error instanceof HttpError ? error.traceId : undefined,
      status: error instanceof HttpError ? error.status : undefined
    }
  };
};
var ignoredErrors = ['SLOIgnoreError', 'SLOIgnoreHttpError'];
export var isIgnoredError = function isIgnoredError(error) {
  var errorName = error === null || error === void 0 ? void 0 : error.constructor.name;
  if (!errorName) {
    return false;
  }
  return ignoredErrors.includes(errorName);
};